import React from "react"
import ReactDOM from "react-dom"
import MerchantPageOtherStores from "./merchant-page-other-stores"

export default class MerchantPageOtherStoresModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.headline = elem.dataset.headline
    self.merchants = elem.dataset.merchants && JSON.parse(elem.dataset.merchants)
    self.bottomPadding = elem.dataset.bottomPadding
    self.topPadding = elem.dataset.topPadding
    self.topDeck = elem.dataset.topDeck
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <MerchantPageOtherStores
        headline={self.headline}
        merchants={self.merchants}
        bottomPadding={self.bottomPadding}
        topPadding={self.topPadding}
        topDeck={self.topDeck}
        cssClass={"theme-main-platinum-faded"}
      />,
      self.elem,
    )
  }
}
